import { DefaultTheme } from 'styled-components'

export const theme: DefaultTheme = {
  splash: {
    bg: 'var(--color-bg-primary)',
    gradient:
      'linear-gradient(90deg, var(--color-bg-primary) 0%, var(--color-bg-secondary) 100%)',
    logoFill: 'var(--color-primary)',
    progressBg: 'var(--color-bg-secondary)',
    progressAfterBg: 'var(--color-primary)',
    titleColor: 'var(--color-text-primary)',
    subTitleColor: 'var(--color-text-secondary)',
    iconColor: 'var(--color-text-light)',
  },
  layout: {
    bg: 'var(--color-bg-primary)',
    contentBoxShadowColor: 'var(--color-shadow)',
  },
  sidebar: {},
  search: {
    iconColor: 'var(--color-text-light)',
  },
  options: {
    bg: 'var(--color-bg-primary)',
    boxShadow: 'var(--color-shadow)',
  },
  unselectedChat: {
    bg: 'var(--color-bg-secondary)',
  },
  chatRoom: {
    bg: 'var(--color-bg-primary)',
    scrollBtnBoxShadow: 'var(--color-shadow)',
    profileBoxShadow: 'var(--color-shadow)',
    profileHeadingColor: 'var(--color-text-primary)',
    profileActionColor: 'var(--color-error)',
  },
  common: {
    borderColor: 'var(--color-border)',
    DCprimaryColor: 'var(--color-primary)',
    mainHeadingColor: 'var(--color-text-primary)',
    subHeadingColor: 'var(--color-text-secondary)',
    secondaryColor: 'var(--color-secondary)',
    tertiaryColor: 'var(--color-info)',
    readIconColor: 'var(--color-success)',
    unreadIconColor: 'var(--color-text-light)',
    headerIconColor: 'var(--color-text-light)',
  },
  alert: {
    infoColor: 'var(--color-info)',
    iconContainerColor: 'var(--color-bg-primary)',
    closeIconColor: 'var(--color-text-light)',
  },
  badge: {
    textColor: 'var(--color-text-on-primary)',
    bgColor: 'var(--color-primary)',
  },
  sentMessage: {
    textColor: 'var(--color-text-on-primary)',
    bgColor: 'var(--color-primary)',
  },
  receivedMessage: {
    textColor: 'var(--color-text-primary)',
    bgColor: 'var(--color-bg-secondary)',
  },
  encryptionMessage: {
    textColor: 'var(--color-text-primary)',
    bgColor: 'var(--color-warning)',
  },
}
